function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 161.335 161.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-83.026 -64.74)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 151.411,
    height: 151.411,
    x: 87.988,
    y: 69.702,
    ry: 12.603,
    style: {
      fill: "#009de6",
      fillOpacity: 1,
      stroke: "#009de6",
      strokeWidth: 9.924,
      strokeLinecap: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.09 151.07 21.162 21.885 55.58-54.26",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 9.89986,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxOn);
export default __webpack_public_path__ + "static/media/checkbox-on.2b5c741f71cb71450d3f0089b47350c9.svg";
export { ForwardRef as ReactComponent };